import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Input from './Input';

export default function NewCheckBox(props) {

    const {
        type,
        title,
        value,
        setValue
    } = props;

    return (
        <>
            <div className='check_div_box'
                onClick={() => {
                    if(setValue) setValue(!value);
                }}
            >
                <div>
                    {value ?
                        <img src={`./images/icons/${type === 'red' ? 'red_check_box' : 'blue_check_box'}.svg`} width='20' />
                        :
                        <img src="./images/icons/check_box_blank.svg" width='20' />
                    }
                </div>
                <p>{title}</p>
            </div>
        </>
    )    
}